import EntityReferenceData = namaTypes.EntityReferenceData;
import StringConstants from "@/utils/constants/StringConstants.ts";

export default class DimensionsUtil {
  static isNullDimension(dim: EntityReferenceData | undefined | null): boolean {
    if (!dim)
      return false;
    return dim.code === StringConstants.DIMENSION_NULL_CODE;
  }

  static isNotNullDimension(dim: EntityReferenceData | undefined | null): boolean {
    return !this.isNullDimension(dim);

  }
}
